// extracted by mini-css-extract-plugin
export default {"services-table":"ShopServicesTable_services-table__iktet"};